//
import SlGroupedOfferModel from '@/models/Sale/SlGroupedOffer'

/**
 * This class describes a sl grouped offer.
 * @class      SlGroupedOffer (name)
 */
export default class SlGroupedOffer extends SlGroupedOfferModel {
  /**
   * Returns a list representation of the object.
   * @return     {Object}  List representation of the object.
   */
  static toList() {
    //
    this.includes = ['sl_offers.wh_product']

    //
    return this
  }
}
